export const isActive = (
  activePath: string,
  linkHref: string,
  subLinks
): boolean =>
  subLinks.some((el) => activePath.includes(el.href)) ||
  activePath === linkHref;
